import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import PaymentLoadingModal from "../../Components/Common/Model/PaymentLoadingModal";
import ConfirmCancelModal from "../../Components/Utility/ConfirmCancelModal";
import ExperienceMap from "../../Components/Utility/ExperienceMap";
import {
  BookingSkeleton,
  BoxSkeleton,
  ImageSkeleton,
} from "../../Components/Utility/Skeletons";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function UserExperienceDetail() {
  const { booking_id } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [baseUrl, setBaseUrl] = useState("");
  const [error, setError] = useState(null);
  const [cancelPolicy, setCancelPolicy] = useState([]);

  const [policyLoading, setPolicyLoading] = useState(true);

  const [isCancelling, setIsCancelling] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [refund, setRefund] = useState(false);
  const token = localStorage.getItem("authToken");
  const storedUser = localStorage.getItem("user");

  // const handleCancellationRequest = async () => {
  //   setShowConfirm(true);
  // };

  const handleCancellationRequest = async () => {
    const bookingDate = new Date(booking.booking_date);
    const cutoffDate = new Date(bookingDate);
    cutoffDate.setDate(
      cutoffDate.getDate() - (booking.cancellation_duration || 0)
    );

    const now = new Date();

    // ✅ Check refund eligibility
    const refundEligible = now <= cutoffDate;
   

    setRefund(refundEligible);
    setShowConfirm(true);
  };

  const handleConfirmCancel = async () => {
    setShowConfirm(false);
    if (isCancelling || !booking) return;

    if (booking.cancel_status === 0 && booking.cancel_by === 1) {
      toast.error("Cancellation request is already under process.");
      return;
    }

    try {
      setIsCancelling(true);
      const token = localStorage.getItem("authToken");

      // Determine API endpoint based on cancel_status
      const endpoint =
        booking.cancel_status === null
          ? `${process.env.REACT_APP_API_BASE}/user/cancel-booking-request/${booking.booking_id}`
          : `${process.env.REACT_APP_API_BASE}/user/booking-cancel-confirm/${booking.booking_id}`;

      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status) {
        toast.success(
          booking.cancel_status === null
            ? "Cancellation request sent successfully."
            : "Booking cancelled successfully."
        );

        // Optionally refresh booking details to reflect new status
        await fetchBookingDetails();
      } else {
        toast.error(res.data?.message || "Action failed. Please try again.");
      }
    } catch (err) {
      const apiMessage =
        err.response?.data?.message ||
        "Something went wrong while processing the request.";
      toast.error(apiMessage);
    } finally {
      setIsCancelling(false);
    }
  };

  const fetchBookingDetails = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/user/booking-details/${booking_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.status) {
        setBooking(res.data.data);
        setBaseUrl(res.data.base_url); // ✅ store base url
      } else setError("Booking details not found.");
    } catch (err) {
      console.error(err);
      setError("Failed to fetch booking details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCancelPolicyData = async () => {
    try {
      setPolicyLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "cancellation-policy",
        }
      );

      if (res.data?.status && res.data?.data?.content) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(res.data.data.content, "text/html");

        // Select div with actual CMS class
        const divs = Array.from(
          doc.querySelectorAll(".faq_contentss, .itm_list_ar, div")
        );

        // Extract text
        const listItems = divs
          .map((div) => div.textContent.trim())
          .filter(Boolean);

        setCancelPolicy(listItems);
      } else {
        console.warn("No content found in CMS API:", res.data);
      }
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
      toast.error("Failed to load cancellation policy");
    } finally {
      setPolicyLoading(false);
    }
  };

  useEffect(() => {
    if (booking_id) {
      fetchBookingDetails();
      fetchCancelPolicyData();
    }
  }, [booking_id]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
  }, []);

  const navigate = useNavigate();

  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = ((hour + 11) % 12) + 1;
    return `${hour12}:${minutes} ${suffix}`;
  };

  const handleMessageClick = async () => {
    const hostData = {
      user_id: booking?.package_data?.created_by,
      first_name: booking?.host_first_name,
      last_name: booking?.host_last_name,
      email: booking?.email,
      profile_image: booking?.host_profile_pic,
    };

    navigate("/chat", { state: { chatTarget: hostData } });
  };

  // Helper function to format the URL
  const getExperienceUrl = (url_slug) => {
    return `/experience/${url_slug}`;
  };

  if (loading) {
    return (
      <section className="ser_v_araeea host_expert checkout user_allls pt-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <BookingSkeleton height="250px" />
            </div>
            <div className="col-lg-6">
              <BoxSkeleton height="250px" />
            </div>
            <div className="col-lg-12 mt-4">
              <ImageSkeleton height="300px" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) return <p className="text-center py-4 text-red-600">{error}</p>;
  if (!booking) return <p className="text-center py-4">No booking found.</p>;

  return (
    <>
      {/* <!-- Confirm and pay --> */}
      <section className="ser_v_araeea host_expert checkout user_allls pt-4">
         <SetMetaTags
                title={booking.experience_title}
                description=""
                keywords=""
              />

        <div className="bedcramss">
          <Link to="/profile">Dashboard</Link> &gt;{" "}
          <Link to="/user-experience">Experience</Link> &gt; Booking Detail
        </div>
        <div className="containerdfgdf">
          <div className="top_bk_areaa host_exce_dtls">
            <h4>Your Booking Details</h4>
            <p>
              Booking ID : <span>{booking.booking_id}</span>
            </p>

            <div className="contxt_tx_bx othreenss messeg">
              <div className="linkss">
                {/*<a href="">Download Invoice</a>
                      <a href="">Download Rules & Policies</a >*/}
                {booking?.exp_cancel_status !== 2 && (
                  <div className="cancel_div">
                    {booking?.cancel_status === null && (
                      <button
                        className="cancel_button"
                        onClick={handleCancellationRequest}
                        disabled={isCancelling}
                      >
                        {isCancelling
                          ? "Cancelling..."
                          : "Request for Cancellation"}
                      </button>
                    )}

                    {booking?.cancel_status === 0 &&
                    booking?.cancel_by === 1 ? (
                      <button className="cancel_button status_pending" disabled>
                        Pending
                      </button>
                    ) : booking?.cancel_status === 0 &&
                      booking?.cancel_by !== 1 ? (
                      <button
                        className="cancel_button "
                        onClick={handleCancellationRequest}
                      >
                        {isCancelling ? "Cancelling..." : "Cancel Booking"}
                      </button>
                    ) : null}

                    {booking?.cancel_status === 1 && (
                      <button className="cancel_button status_approve" disabled>
                        Booking Cancelled
                      </button>
                    )}
                  </div>
                )}
              </div>

              <span>{booking?.data?.host_about_me} </span>
              <h6
                className="btnnss"
                style={{ cursor: "pointer" }}
                onClick={handleMessageClick}
              >
                Message Host
              </h6>
            </div>
          </div>

          <div className="row">
            {booking?.cancel_by === 2 && (
              <div className="col-lg-12">
                <div className="clk_liststs reason_area">
                  <h4>Reason :</h4>
                  <p>{booking.cancel_reason || "N/A"}</p>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <div className="chek_bx_txt">
                <div className="meddils">
                  <div
                    className="mg_arease"
                    onClick={() =>
                      navigate(
                        getExperienceUrl(
                          booking?.url_slug
                        )
                      )
                    }
                  >
                    <img
                      src={
                        booking?.host_images?.length > 0
                          ? `${baseUrl}${booking.host_images[0].image}`
                          : "/images/user_dh.png"
                      }
                      alt={booking.experience_title || "Experience"}
                      className="img-fluid"
                    />
                  </div>
                  <div className="dtls_rightss tetx_arease">
                    <h3
                      onClick={() =>
                        navigate(
                          getExperienceUrl(
                            booking?.url_slug
                          )
                        )
                      }
                    >
                      {booking.experience_title}
                    </h3>
                    <div className="us_listst">
                      <ul>
                        <li>
                          <i className="fa fa-star"></i>{" "}
                          {booking.average_rating}/5
                        </li>
                        <li
                          className={
                            booking.reviews_count > 0 ? "" : "platforma_cursor"
                          }
                          onClick={() => {
                            if (booking.reviews_count > 0) {
                              navigate(
                                getExperienceUrl(
                                  booking?.url_slug
                                )
                              );
                            }
                          }}
                        >
                          {booking.reviews_count || 0} reviews
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="ck_ckalsinss">
                    <div className="clk_liststs">
                      <h4>Date</h4>

                      <p>
                        {booking.booking_date},{" "}
                        {formatTimeTo12Hour(booking.booking_from_time)} -{" "}
                        {formatTimeTo12Hour(booking.booking_to_time)}
                      </p>
                    </div>
                    <div className="clk_liststs">
                      <h4>Organised By </h4>
                      <p>
                        {booking.host_first_name} {booking.host_last_name}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="chek_bx_txtrigt">
                <div className="ck_ckalsinsses">
                  <div className="clk_liststs">
                    <h4>Payment Mode</h4>
                    <p>{booking.payment_method || "Credit Card"}</p>
                  </div>
                  <div className="clk_liststs">
                    <h4>Booking ID</h4>
                    <p>{booking.booking_id || "N/A"}</p>
                  </div>
                </div>

                <div className="hst_us_txttx couponbooking">
                  <h6>Price details</h6>

                  {/* Adult Price */}
                  {booking.guest_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_guest || 0).toFixed(2)} ×{" "}
                      {booking.guest_count} adult
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_guest || 0) *
                          Number(booking.guest_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {/* Children Price */}
                  {booking.children_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_child || 0).toFixed(2)} ×{" "}
                      {booking.children_count} child
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_child || 0) *
                          Number(booking.children_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {/* Infant Price */}
                  {booking.infants_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_infant || 0).toFixed(2)} ×{" "}
                      {booking.infants_count} infant
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_infant || 0) *
                          Number(booking.infants_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {booking?.discount && booking?.coupon_code && (
                    <p className="d-flex justify-content-between text-success mt-2 coupon-discount-price">
                      <span>Discount {booking?.coupon_code ? `(${booking.coupon_code})` : ""}</span>
                      <span>
                        {booking.currency_symbol || "$"}{(booking?.discount)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  

                  <h5>
                    Total Amount
                    <span className="lasts">
                      {booking.currency_symbol || "$"}
                      {Number(booking.total_price || 0).toFixed(2)}{" "}
                      {booking.currency || "AUD"}
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="hst_us_txttx user_exprincess">
                <div className="lft_txt">Key Highlights</div>
                <div className="lft_txtrts">
                  {booking?.package_data && (
                    <div className="package-section mb-4 mt-3">
                      <h5 className="fw-bold mb-2">Package Details</h5>
                      <div className="package-info">
                        <p>
                          <strong>Title:</strong> {booking.package_data.title}
                        </p>
                      </div>
                    </div>
                  )}

                  {booking?.itinerary?.length > 0 && (
                    <div className="hst_us_txttx">
                      <div className="lft_txt">Itinerary</div>
                      <div className="itinerary-grid">
                        {booking.itinerary.map((item, index) => (
                          <div
                            className="itinerary-card boths_mngggs"
                            key={item.id || index}
                          >
                            {item.image && (
                              <div className="itinerary_div">
                                <img
                                  src={`${baseUrl}${item.image}`}
                                  alt={item.activity_title}
                                  className="itinerary-img"
                                />
                              </div>
                            )}
                            <div
                              className={`itinerary-info ${
                                item.image ? "" : "images_booking"
                              }`}
                            >
                              <h6>{item.activity_title || "Activity"}</h6>
                              <p className="itinerary-place">
                                <i className="fa fa-map-marker-alt me-1 text-danger"></i>{" "}
                                {item.place}
                              </p>
                              <p className="itinerary-time">
                                <i className="fa fa-clock me-1"></i>{" "}
                                {formatTimeTo12Hour(item.activity_time)}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="map_bothss">
                {/* <div className="mgs_ar">
    
    {booking?.host_images?.length > 0 && (
      <div className="mgs_ar">
        <img
          src={`${baseUrl}${booking.host_images[0].image}`}
          alt={booking.experience_title}
          className="img-fluid"
          style={{ borderRadius: "8px" }}
        />
      </div>
    )}
  </div> */}
                <div
                  className="maps"
                  style={{ width: "100%", height: "300px", maxWidth: "100%" }}
                >
                  {/* <iframe
      width="100%"
      height="100%"
      frameBorder="0"
      style={{ border: 0 }}
      src={`https://www.google.com/maps?q=${encodeURIComponent(
        `${booking.experience_house_no}${booking.experience_locality}, ${booking.experience_pin_code}${booking.city_name},${booking.country_name}`
      )}&output=embed`}
      allowFullScreen
      title="Experience Location"
    ></iframe> */}

                  <ExperienceMap
                    experienceData={booking}
                    house_no={booking?.experience_house_no}
                    locality={booking.experience_locality}
                    city={booking?.city_name}
                    country={booking?.country_name}
                  />
                </div>
              </div>

              <div className="ck_ckalsinss host_exstet">
                <div className="clk_liststs">
                  <h4>Cancellation Policy</h4>
                  {booking?.cancellation_policy ? (
    <div
      dangerouslySetInnerHTML={{ __html: booking.cancellation_policy }}
    />
  ) : (
    <p>No cancellation policy found.</p>
  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ConfirmCancelModal
        show={showConfirm}
        refundEligible={refund}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirmCancel}
      />

      <PaymentLoadingModal isOpen={isCancelling} type="cancelling" />
    </>
  );
}

export default UserExperienceDetail;
